import React from "react";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { toTitleCase } from '../../utils/stringManipulations';
import I18N from '../../I18N';
import trash from '../../assets/icons/Icon-Delete-Gray.svg';
import closeIcon from '../../assets/icons/Icon-Close.svg';
import "./SiteScheduledRecordings.scss";

const SiteScheduledRecordings = ({ records, onClose, onDelete })=> {
  const headers = ["date", "time", "duration", "team"];
  return (
    <div className="site-scheduled-recordings" data-testid="site-scheduled-recordings">
      <button className="site-scheduled-recordings__close-button" type="button" onClick={onClose}>
        <img src={closeIcon} alt=""/>
      </button>
      <p className="site-scheduled-recordings__title">{toTitleCase(I18N.t("RECORDING_SCHEDULE"))}</p>
      <div className="site-scheduled-recordings__table">
        <div className="site-scheduled-recordings__table__headers grid-size">
          {headers.map(header => <span>{toTitleCase(header)}</span>)}
          <span />
        </div>
        <div className="site-scheduled-recordings__table__body">
          {records.map(record => 
            <div key={record._id} className="site-scheduled-recordings__table__body__single-record grid-size">
              <span>{dayjs(record.startTime).format("ddd, D MMMM")}</span>
              <span>{dayjs(record.startTime).format("hh:mm a")}</span>
              <span>{`${record.duration/60}Hr`}</span>
              <span>{record.team.name}</span>
              <button 
                type="button" 
                style={{ display: "flex", justifyContent: "flex-end" }} 
                onClick={()=> onDelete(record)}
                data-testid="delete-task-button"
              >
                <img className="site-scheduled-recordings__table__body__single-record__trash" src={trash} alt=""/>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SiteScheduledRecordings.propTypes = {
  onClose: PropTypes.func,
  onDelete: PropTypes.func, 
  records: PropTypes.array
};

SiteScheduledRecordings.defaultProps = {
  onClose: ()=> {}, 
  onDelete: ()=> {}, 
  records: []
};

export default SiteScheduledRecordings;